var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      staticClass: "sub-menu",
      staticStyle: { "margin-bottom": "15px" },
      attrs: { "slider-color": "primary" }
    },
    [
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/role", exact: "" }
        },
        [_vm._v(" " + _vm._s(_vm.$t("settings.rolesMenu.role")) + " ")]
      ),
      _vm.$store.getters["userProperties"].system_settings
        .is_module_travel_service_enabled === 2 ||
      _vm.$store.getters["userProperties"].system_settings
        .is_module_delegation_enabled === 2
        ? _c(
            "v-tab",
            {
              staticClass: "sub-menu-item",
              attrs: { to: "/settings/role/deputy-auth" }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("settings.rolesMenu.delegatedPermissions")) +
                  " "
              )
            ]
          )
        : _vm._e(),
      _vm.$store.getters["userProperties"].system_settings
        .is_module_travel_service_enabled === 2 ||
      _vm.$store.getters["userProperties"].system_settings
        .is_module_delegation_enabled === 2
        ? _c(
            "v-tab",
            {
              staticClass: "sub-menu-item",
              attrs: { to: "/settings/role/mapping" }
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("settings.rolesMenu.wnbRoleMapping")) + " "
              )
            ]
          )
        : _vm._e(),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/role/default" }
        },
        [_vm._v(" " + _vm._s(_vm.$t("settings.rolesMenu.defaultRoles")) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }